import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { APIProvider } from '@vis.gl/react-google-maps';
import SearchField from '../Map/SearchField';
import ClinicResults from './ClinicResults';
import ServiceFilter from './ServiceFilter';

const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? 'AIzaSyDKR2D-xrjNTAS-Ug5cL78tV5uwTkcIK0w';

const servicesData = {
    "travel": "Travel Services",
    "sh": "Sexual Health",
    "vaccinations": "Vaccinations",
    "blood-tests": "Blood Testing",
    "private-gp": "Private GP"
};

ClinicFinder.propTypes = {
    defaultAddressValue: PropTypes.string,
    defaultRadiusValue: PropTypes.number
};

export default function ClinicFinder ({
    defaultAddressValue = '',
    defaultRadiusValue = 50,
    config
}) {

    const [ selectedAddress, setSelectedAddress ] = useState(defaultAddressValue);
    const [ radius, setRadius ] = useState(defaultRadiusValue);
    const [ clinicData, setClinicData ] = useState([]);
    const [ service, setService ] = useState(config.service ? config.service : null);
    const [ loading, setLoading ] = useState(true);

    const onSelectAddress = (updatedObj) => {
        setSelectedAddress(updatedObj);
    };

    const onServiceChange = (service) => {
        setService(service);
    };

    const onRadiusChange = (radius) => {
        setRadius(radius);
    };

    const getClinicData = async () => {

        let url = '/cd/feeds/finder/clinics';

        if (service) {
            url += '/'+service;
        }

        fetch(url)
            .then(response => response.json())
            .then(data => {
                setClinicData(data);
            })
            .catch(error => {
                console.error(error);
            });

    };

    const setIsLoading = (value) => {
        setLoading(value);
    }

    useEffect(() => {
        setLoading(true);
        getClinicData();
    }, [service]);

    return (
        <APIProvider apiKey={apiKey}>

            <div className="clinic-finder">

                    <div className="clinic-finder__header">
                    
                        <h3 className="clinic-finder__title">{ config.title ? config.title : 'Your nearest CityDoc clinic'}</h3>
                        
                        { config.intro && (
                            <p className="clinic-finder__intro">{ config.intro}</p>
                        )} 

                        <ServiceFilter services={servicesData} selectedService={service} onServiceChange={onServiceChange} />

                        <SearchField
                            onSelectAddress={onSelectAddress}
                            onRadiusChange={onRadiusChange}
                            defaultAddressValue={defaultAddressValue}
                            defaultRadiusValue={defaultRadiusValue}
                        />
                
                    </div>

                    <div className="clinic-finder__content">
                    
                        { clinicData && (
                            <ClinicResults selectedAddress={selectedAddress} radius={radius} clinicData={clinicData} service={service} loading={loading} setIsLoading={setIsLoading} />
                        )}    

                        { config && (
                            <div className="clinic-finder-key">
                                <span className="clinic-finder-key__item">
                                    <img
                                        className="clinic-finder-key__icon"
                                        src={'/wp-content/themes/bedrock-theme/static/images/clinic-marker-blue.svg'}
                                        alt="Map Marker Icon"
                                        width={28}
                                        height={46}
                                    />
                                    { config.markers.blue ? config.markers.blue : ''}
                                </span>
                                <span className="clinic-finder-key__item">
                                    <img
                                        className="clinic-finder-key__icon"
                                        src={'/wp-content/themes/bedrock-theme/static/images/clinic-marker-teal.svg'}
                                        alt="Map Marker Icon"
                                        width={28}
                                        height={46}
                                    />
                                    { config.markers.blue ? config.markers.teal : ''}
                                </span>
                            </div>
                        )}

                    </div>              

            </div>

        </APIProvider>
        
    );
};